import React, { Fragment, useEffect } from "react";
import Message from "../../CommonData/Data/Message";
import { Button, Form, FormFeedback, FormGroup, Input, Label } from "reactstrap";
import VWLoading from "../../components/vwLoading/vwLoading";
import { connect } from "react-redux";
import { addAppVersion, appVersionCreate, clearCreateAppVersionError } from "../../store/appVersion/actions";

const AddAppVersion = (props) => {
    const { handleClose, errorMessage, isCreatePending, addAppVersionForm } = props;
    const { formAddAppVersion } = addAppVersionForm || {};
    const { VersionNo, ReleasedDate, Notes } = formAddAppVersion || {};

    useEffect(() => {
        props.addAppVersion({
            formAddAppVersion: {},
            errors: {}
        })

        props.clearCreateAppVersionError();
        //--------------------Key-Listener----------------------
        const handleKeyPress = (e) => {
            if (e.key === "Escape") {
                handleClose();
            }
        };

        window.addEventListener('keydown', handleKeyPress);

        return () => {
            window.removeEventListener('keydown', handleKeyPress);
        };
    }, [])

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        event.preventDefault();
        props.addAppVersion({
            formAddAppVersion: {
                ...addAppVersionForm.formAddAppVersion,
                [name]: value
            },
            errors: {
                ...addAppVersionForm && addAppVersionForm.errors,
                [name]: null,
            }
        });
    }

    const handleCreateAppVesrion = (e) => {
        e.preventDefault();
        const { formAddAppVersion } = addAppVersionForm || {};
        const { VersionNo, ReleasedDate, Notes } = formAddAppVersion || {};
        const currentErrors = {};

        if (!VersionNo) {
            currentErrors.VersionNo = "Version no. is required"
        }

        if (!ReleasedDate) {
            currentErrors.ReleasedDate = "Release date is required"
        }

        props.addAppVersion({
            formAddAppVersion: {
                ...addAppVersionForm.formAddAppVersion,
            },
            errors: currentErrors,
        })

        if (Object.keys(currentErrors).length === 0) {
            props.appVersionCreate(addAppVersionForm.formAddAppVersion);
        }
    };

    return isCreatePending ? (<VWLoading />) : (
        <Fragment>
            {errorMessage && (
                <Message type="danger" defaultMessage={errorMessage} baseClassName="alert" />
            )}
            <Form onSubmit={handleCreateAppVesrion}>
                <FormGroup>
                    <Label>Version No.</Label><span className="text-danger">*</span>
                    <Input
                        autoFocus
                        type="text"
                        name="VersionNo"
                        placeholder="Enter version no."
                        onChange={handleInputChange}
                        value={VersionNo || ""}
                        invalid={addAppVersionForm && addAppVersionForm.errors && addAppVersionForm.errors.VersionNo}
                    />
                    <FormFeedback>{addAppVersionForm && addAppVersionForm.errors && addAppVersionForm.errors.VersionNo}</FormFeedback>
                </FormGroup>
                <FormGroup>
                    <Label>Release Date</Label><span className="text-danger">*</span>
                    <Input
                        type="date"
                        name="ReleasedDate"
                        placeholder="Enter release date "
                        onChange={handleInputChange}
                        value={ReleasedDate || ""}
                        invalid={addAppVersionForm && addAppVersionForm.errors && addAppVersionForm.errors.ReleasedDate}
                    />
                    <FormFeedback>{addAppVersionForm && addAppVersionForm.errors && addAppVersionForm.errors.ReleasedDate}</FormFeedback>
                </FormGroup>
                <FormGroup>
                    <Label>Notes</Label>
                    <Input
                        type="textarea"
                        name="Notes"
                        placeholder="Enter notes"
                        onChange={handleInputChange}
                        value={Notes || ""}
                    />
                </FormGroup>
                <FormGroup>
                    <Button
                        type="submit"
                        className='me-4'
                        color="success"
                        onClick={handleCreateAppVesrion}
                    >
                        Create
                    </Button>
                    <Button
                        color="danger"
                        onClick={handleClose}
                    >
                        Cancel
                    </Button>
                </FormGroup>
            </Form>

        </Fragment>
    );
}

const mapStateToProps = (state) => ({
    addAppVersionForm: state.appVersion.addAppVersionForm,
    isCreatePending: state.appVersion.isAppVersionCreatePending,
    errorMessage: state.appVersion.appVersionCreateErrorMessage,
});

const mapDispatchToProps = (dispatch) => ({
    addAppVersion: (addAppVersionForm) => dispatch(addAppVersion(addAppVersionForm)),
    clearCreateAppVersionError: () => dispatch(clearCreateAppVersionError()),
    appVersionCreate: (AddProduct) => dispatch(appVersionCreate(AddProduct)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddAppVersion);